// Unknown public path (anything outside /cave that doesn't match a door).
import { Link } from 'react-router-dom';
import { Opener } from '../Opener.js';

export function LostPage() {
  return (
    <>
      <Opener lines={['Lost at', 'sea']} />
      <section className="wrap section">
        <p className="prose big">
          <Link to="/">Back to the harbour</Link>
        </p>
      </section>
    </>
  );
}
